// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","rotator":"spinner_rotator__KvWgg","path":"spinner_path__1MbtH","dash":"spinner_dash__2fNUP"};